document.addEventListener("DOMContentLoaded", () => {
    
    if (!customElements.get('bundle-deals')) {
        class BundleDeals extends HTMLElement {

            _shopify_features_script = document.querySelector(
                "script[id='shopify-features']"
            );
            _shopify_features_json = JSON.parse(
                this._shopify_features_script.innerHTML
            );
            _checkout_headers = {
                Accept: "application/json",
                "Content-Type": "application/json",
                authorization: "Basic " + btoa(this._shopify_features_json.accessToken),
            };

            constructor() {
                super();
                this.tabItems = this.querySelectorAll('.bundle-deals__tab-item');
                this.tabContents = this.querySelectorAll('.bundle-deals__tab-container');
                this.productList = this.querySelectorAll('.bundle-deals__product');
                this.twoDiscount = Number(this.dataset.twoDiscount);
                this.threeDiscount = Number(this.dataset.threeDiscount);
                // this.fourDiscount = Number(this.dataset.fourDiscount);
                this.addCartBtn = this.querySelector('.bundle-deals__add-cart');
                this.addBuyBtn = this.querySelector('.bundle-deals__buy-now');

                this.currentTab = "";
                this.selectProducts = [];
                this.initTab();
                this.initProductEvent();
                this.initTabDrag();
                
            }
            initTabDrag() {
                const wrap = this.querySelector('.bundle-deals__tab-list');
                if (!wrap) return;

                let isDown = false;
                let startX = 0;
                let scrollLeft = 0;
                let moved = false;

                // 鼠标
                wrap.addEventListener('mousedown', (e) => {
                    isDown = true;
                    moved = false;
                    startX = e.pageX;
                    scrollLeft = wrap.scrollLeft;
                });

                wrap.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    const x = e.pageX;
                    const walk = x - startX;
                    if (Math.abs(walk) > 5) moved = true;
                    wrap.scrollLeft = scrollLeft - walk;
                });

                wrap.addEventListener('mouseup', () => {
                    isDown = false;
                });

                wrap.addEventListener('mouseleave', () => {
                    isDown = false;
                });

                // 手机
                wrap.addEventListener('touchstart', (e) => {
                    startX = e.touches[0].pageX;
                    scrollLeft = wrap.scrollLeft;
                    moved = false;
                }, { passive: true });

                wrap.addEventListener('touchmove', (e) => {
                    const x = e.touches[0].pageX;
                    const walk = x - startX;
                    if (Math.abs(walk) > 5) moved = true;
                    wrap.scrollLeft = scrollLeft - walk;
                }, { passive: true });

                // 🔥 阻止「拖动时误触 click」
                this.tabItems.forEach(item => {
                    item.addEventListener('click', (e) => {
                    if (moved) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    }
                    }, true);
                });
                }


            connectedCallback() {
                this.elements = {
                    loadingSpinner: this.querySelector(".loading__spinner"),
                };
                this.addCartBtn.addEventListener("click", (e) => {
                    this.startLoading(this.addCartBtn);
                    this.addToCart()
                    .then(response => {
                        this.updateAndShowCart(response);
                    })
                    .finally(() => {
                        this.finishLoading(this.addCartBtn);
                        
                    });
                });

                this.addBuyBtn.addEventListener("click", (e) => {
                    this.startLoading(this.addBuyBtn);
                    this.addToCart()
                    .then(response => {
                        this.updateCartInfo();
                    }).finally(() => {
                        this.finishLoading(this.addBuyBtn);
                        window.location.href = '/checkout';

                    });
                });
            }

            async addToCart() {
                const items = this.selectProducts.map((product, index) => {
                    console.log('product',product)
                    return {
                    form_type: "product",
                    utf8: "✓",
                    id: product.productVariantId,
                    quantity: product.quantity
                    };
                });
                
                let data_json = {
                    items: items,
                };

                let data = JSON.stringify(data_json);
                return fetch("/cart/add.json", {
                    method: "POST",
                    headers: this._checkout_headers,
                    body: data,
                }).then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        if (response.status === 422) {
                        alert("Inventory shortage!");
                        }
                        throw new Error("请求失败");
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
            }

            /**
             * 更新购物车，并弹出侧边购物车
             * @returns
             */
            async updateCartInfo(response) {
                this.onCartUpdate();
            }

            /**
             * 更新购物车，并弹出侧边购物车
             * @returns
             */
            async updateAndShowCart(response) {
                this.onCartShow();
            }

            onCartShow() {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(
                        responseText,
                        "text/html"
                    );
                    const targetElement = document.querySelector("cart-drawer");
                    const sourceElement = html.querySelector("cart-drawer");
                    targetElement.innerHTML = sourceElement.innerHTML;
                    targetElement.classList.add("active");
                    targetElement.classList.remove("is-empty");
                    document.querySelector("body").classList.add("overflow-hidden");
                })
                .catch((e) => {
                    console.error(e);
                });

                fetch(`${routes.cart_url}.js`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((cartData) => {
                    const cartItemCount = cartData.item_count;

                    const cartCountBubbles = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble');
                    if (cartCountBubbles.length === 0) {
                        const cartIcons = document.querySelectorAll('#cart-icon-bubble');
                        cartIcons.forEach((cartIcon) => {
                        const newBubble = document.createElement('div');
                        newBubble.className = 'cart-count-bubble';
                        newBubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
                        cartIcon.appendChild(newBubble);
                        });
                    } else {
                        cartCountBubbles.forEach((bubble) => {
                        bubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
                        });
                    }
                })
                .catch((error) => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
            }

            onCartUpdate() {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(
                        responseText,
                        "text/html"
                    );
                    const targetElement = document.querySelector("cart-drawer");
                    const sourceElement = html.querySelector("cart-drawer");
                    targetElement.innerHTML = sourceElement.innerHTML;
                    // targetElement.classList.add("active");
                    targetElement.classList.remove("is-empty");
                    document.querySelector("body").classList.add("overflow-hidden");
                })
                .catch((e) => {
                    console.error(e);
                });

                fetch(`${routes.cart_url}.js`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((cartData) => {
                    const cartItemCount = cartData.item_count;

                    const cartCountBubbles = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble');
                    if (cartCountBubbles.length === 0) {
                        const cartIcons = document.querySelectorAll('#cart-icon-bubble');
                        cartIcons.forEach((cartIcon) => {
                        const newBubble = document.createElement('div');
                        newBubble.className = 'cart-count-bubble';
                        newBubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
                        cartIcon.appendChild(newBubble);
                        });
                    } else {
                        cartCountBubbles.forEach((bubble) => {
                        bubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
                        });
                    }
                })
                .catch((error) => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
            }

            startLoading(button) {
                button.setAttribute("aria-disabled", true);
                button.classList.add("loading");
                button.querySelector(".loading__spinner").classList.remove("hidden");
            }

            finishLoading(button) {
                button.removeAttribute("aria-disabled");
                button.classList.remove("loading");
                button.querySelector(".loading__spinner").classList.add("hidden");
            }

            initProductEvent() {
                this.productList.forEach(item => {
                    item.addEventListener('click',(e) => {
                        if(e.target.classList.contains('bundle-deals__check-attribute') || 
                            e.target.classList.contains('bundle-deals__image')) {
                            let checked = item.dataset.checked;
                            if(checked == "false") {
                                item.dataset.checked = true;
                                let dataset = {
                                    productId: item.dataset.productId,
                                    productVariantId: item.dataset.variantId,
                                    quantity: item.dataset.quantity,
                                    productPrice: item.dataset.productPrice,
                                    productFeature: item.dataset.productFeature,
                                    productFeatureAlt: item.dataset.productFeatureAlt,
                                    productPrice: item.dataset.productPrice,
                                    productCompare: item.dataset.productCompare,
                                    productTitle: item.dataset.productTitle,
                                    productShortTitle: item.dataset.productShortTitle,
                                }
                                this.selectProducts.push(dataset);
                            }else {
                                item.dataset.checked = false;
                                this.removeProduct(item.dataset.productId);
                            }

                            this.renderSelectedProduct();
                        }

                        
                        
                    })
                });
            }

            removeProduct(productId) {
                this.selectProducts = this.selectProducts.filter(item => item.productId != productId);
            }

            renderSelectedProduct() {
                let selectedProductRender = "";
                this.selectProducts.forEach((product,index) => {
                    console.log('product',product)
                    selectedProductRender += `<div class="bundle-deals__selected-product swiper-slide">
                        <svg  data-product-id="${product.productId}" class="bundle-deals__remove" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.91699 0C12.2892 2.53674e-07 15.834 3.54474 15.834 7.91699C15.834 12.2892 12.2892 15.834 7.91699 15.834C3.54474 15.834 2.53666e-07 12.2892 0 7.91699C0 3.54474 3.54474 0 7.91699 0ZM11.5039 4.33008C11.2721 4.0984 10.8959 4.09856 10.6641 4.33008L7.91699 7.07715L5.16992 4.33008C4.93802 4.09853 4.56184 4.09831 4.33008 4.33008C4.09831 4.56184 4.09853 4.93802 4.33008 5.16992L7.07715 7.91699L4.33008 10.6641C4.09856 10.8959 4.0984 11.2721 4.33008 11.5039C4.56185 11.7356 4.93805 11.7354 5.16992 11.5039L7.91699 8.75684L10.6641 11.5039C10.896 11.7354 11.2722 11.7356 11.5039 11.5039C11.7356 11.2722 11.7354 10.896 11.5039 10.6641L8.75684 7.91699L11.5039 5.16992C11.7354 4.93805 11.7356 4.56185 11.5039 4.33008Z" fill="#B9B9B9"/>
                        </svg>
                        <img src="${product.productFeature}" alt="${product.productFeatureAlt}"/>
                        <div class="bundle-deals__selected-product-info">
                            <div class="bundle-deals__selected-title-price">
                                <div class="bundle-deals__selected-product-title">${product.productShortTitle ? product.productShortTitle : product.productTitle}</div>
                                <div class="bundle-deals__selected-product-price">${this.formatPrice(product.productPrice)}</div>
                            </div>
                            <div class="bundle-deals__selected-product-quantity" data-quantity="1" data-selected-index="${index}">
                                <div class="minus">-</div>
                                <div class="bundle-deals__quantity">${product.quantity}</div>
                                <div class="plus">+</div>
                            </div>
                        </div>
                    </div>`
                });
                // <div class="bundle-deals__selected-product-price">${this.formatPrice(product.productPrice)}</div>
                if (this.swiperInstance) {
                    this.swiperInstance.destroy(true, true);
                    this.swiperInstance = null;
                }

                // 更新DOM
                this.querySelector('.bundle-deals__selected-products').innerHTML = `
                    <div class="swiper-wrapper">
                        ${selectedProductRender}
                    </div>
                `;

                this.initRemoveIcon();
                this.calculatePrice();
                this.initQuantityButton();

                this.initSwiper();
            }

            initSwiper() {
                this.swiperInstance = new Swiper('.bundle-deals__selected-products', {
                    slidesPerView: 2, // 移动端默认显示2个
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-deals__selected__next-button',
                        prevEl: '.swiper-deals__selected__prev-button',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 3.4, // PC端显示4个
                            spaceBetween: 20
                        }
                    }
                });
            }

            initQuantityButton() {
                const minusBtns = this.querySelector('.bundle-deals__selected-products').querySelectorAll('.minus');
                const plusBtns = this.querySelector('.bundle-deals__selected-products').querySelectorAll('.plus');
                minusBtns.forEach(miunsBtn => {
                    miunsBtn.addEventListener('click',() => {
                        const quantityParent = miunsBtn.parentNode;
                        let index = Number(quantityParent.dataset.selectedIndex);
                        let quantity = Number(quantityParent.dataset.quantity);
                        if(quantity > 1) {
                            quantity --;
                            quantityParent.dataset.quantity = quantity;
                        }
                        this.selectProducts[index].quantity = quantity;
                        quantityParent.querySelector('.bundle-deals__quantity').innerText = quantity;
                        this.calculatePrice();
                    })
                });
                plusBtns.forEach(plusBtn => {
                    plusBtn.addEventListener('click',() => {
                        const quantityParent = plusBtn.parentNode;
                        let index = Number(quantityParent.dataset.selectedIndex);
                        let quantity = Number(quantityParent.dataset.quantity);
                        quantity ++;
                        quantityParent.dataset.quantity = quantity;
                        this.selectProducts[index].quantity = quantity;
                        quantityParent.querySelector('.bundle-deals__quantity').innerText = quantity;
                        this.calculatePrice();
                    })
                })
            }

            initRemoveIcon() {
                const removeIcons = this.querySelectorAll('.bundle-deals__remove');
                removeIcons.forEach(item => {
                    item.addEventListener('click',() => {
                        const productId = item.dataset.productId
                        this.removeProduct(productId);
                        this.renderSelectedProduct();
                        this.productList.forEach(product => {
                            if(productId == product.dataset.productId) {
                                product.dataset.checked = false;
                            }
                            
                        })
                    })
                })
            }

            calculatePrice() {
                let selectProductCount = 0;
                
                let price = 0;
                let comparePrice = 0;

                this.selectProducts.forEach((item) => {
                    selectProductCount = selectProductCount + Number(item.quantity);
                    price += Number(item.productPrice) * Number(item.quantity);
                    // comparePrice += item.productCompare ? (Number(item.productCompare) * Number(item.quantity)) : Number(item.productPrice) * Number(item.quantity);
                    comparePrice += Number(item.productPrice) * Number(item.quantity);
                })
                switch(selectProductCount) {
                    case 1:
                        price = price;
                        comparePrice = comparePrice;
                        break;
                    case 2:
                        price = price * this.twoDiscount / 100;
                        // comparePrice = comparePrice * this.twoDiscount / 100;
                        break;
                    case 3:
                        price = price * this.threeDiscount / 100;
                        // comparePrice = comparePrice * this.threeDiscount / 100;
                        break;
                    // case 4:
                        // price = price * this.fourDiscount / 100;
                        // comparePrice = comparePrice * this.fourDiscount / 100;
                        // break;
                    default:
                        price = price * this.threeDiscount / 100;
                        // comparePrice = comparePrice * this.fourDiscount / 100;
                }


                price = this.formatPrice(price);
                this.querySelector('.bundle-deals__total-price').textContent = price;
                comparePrice = this.formatPrice(comparePrice);
                this.querySelector('.bundle-deals__total-compare').textContent = comparePrice;
            }

            formatPrice(priceInCents) {
                const price = priceInCents / 100 * Shopify.currency.rate;
                return new Intl.NumberFormat(Shopify.locale, {
                    style: 'currency',
                    currency: Shopify.currency.active
                }).format(price);
            }

            initTab() {
                this.tabItems.forEach(item => {
                    item.addEventListener('click',() => {
                        const tab = item.dataset.tab;
                        if(tab != this.currentTab) {
                            item.parentNode.querySelector('.active')?.classList.remove('active');
                            item.classList.add('active')
                            this.tabContents.forEach(tabContent => {
                                if(this.currentTab == tabContent.dataset.tab) {
                                    tabContent.classList.remove('active');
                                }
                                if(tab == tabContent.dataset.tab) {
                                    tabContent.classList.add('active');
                                }
                            })
                        }

                        this.currentTab = tab;
                    })
                });

                this.tabItems[0].click();
            }
        }
        customElements.define('bundle-deals', BundleDeals);
    }

    if (!customElements.get('bundle-deals-swiper')) {
        class BundleDealsSwiper extends HTMLElement {

            constructor() {
                super();
                const isMobile = `(max-width: 768px)`;
                const isMobileMQL = window.matchMedia(isMobile);

                isMobileMQL.addEventListener('change', (event) => {
                    console.log(98989)
                    this.initSlider();
                });
                this.initSlider();
                this.initTabDrag();
            }

            initTabDrag() {
                const wrap = this.querySelector('.bundle-deals__tab-list');
                if (!wrap) return;

                let isDown = false;
                let startX = 0;
                let scrollLeft = 0;
                let moved = false;

                // 鼠标
                wrap.addEventListener('mousedown', (e) => {
                    isDown = true;
                    moved = false;
                    startX = e.pageX;
                    scrollLeft = wrap.scrollLeft;
                });

                wrap.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    const x = e.pageX;
                    const walk = x - startX;
                    if (Math.abs(walk) > 5) moved = true;
                    wrap.scrollLeft = scrollLeft - walk;
                });

                wrap.addEventListener('mouseup', () => {
                    isDown = false;
                });

                wrap.addEventListener('mouseleave', () => {
                    isDown = false;
                });

                // 手机
                wrap.addEventListener('touchstart', (e) => {
                    startX = e.touches[0].pageX;
                    scrollLeft = wrap.scrollLeft;
                    moved = false;
                }, { passive: true });

                wrap.addEventListener('touchmove', (e) => {
                    const x = e.touches[0].pageX;
                    const walk = x - startX;
                    if (Math.abs(walk) > 5) moved = true;
                    wrap.scrollLeft = scrollLeft - walk;
                }, { passive: true });

                // 🔥 阻止「拖动时误触 click」
                this.tabItems.forEach(item => {
                    item.addEventListener('click', (e) => {
                    if (moved) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    }
                    }, true);
                });
                }


            initSlider() {
                const pagination = this.querySelector('.pagination')
                const prevButton = this.querySelector('.swiper-deals__tab__prev-button')
                const nextButton = this.querySelector('.swiper-deals__tab__next-button')
                new Swiper(this, {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                    navigation: {
                        prevEl: prevButton,
                        nextEl: nextButton
                    },
                    breakpoints: {
                        340: {
                            slidesPerView: 2,
                            spaceBetween: 12,
                        },
                        769: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        }
                    }
                })
            }
        }
        customElements.define('bundle-deals-swiper', BundleDealsSwiper);
    }
})
